/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A promotion item for the promotions section.
 * @export
 * @interface ChallengePromotionItem
 */
export interface ChallengePromotionItem {
    /**
     * Asset ID for promotion image
     * @type {string}
     * @memberof ChallengePromotionItem
     */
    imageId?: string;
    /**
     * CDN URL for promotion image (in response)
     * @type {string}
     * @memberof ChallengePromotionItem
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengePromotionItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengePromotionItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengePromotionItem
     */
    url?: string;
}

/**
 * Check if a given object implements the ChallengePromotionItem interface.
 */
export function instanceOfChallengePromotionItem(value: object): value is ChallengePromotionItem {
    return true;
}

export function ChallengePromotionItemFromJSON(json: any): ChallengePromotionItem {
    return ChallengePromotionItemFromJSONTyped(json, false);
}

export function ChallengePromotionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengePromotionItem {
    if (json == null) {
        return json;
    }
    return {
        
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function ChallengePromotionItemToJSON(json: any): ChallengePromotionItem {
    return ChallengePromotionItemToJSONTyped(json, false);
}

export function ChallengePromotionItemToJSONTyped(value?: ChallengePromotionItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'description': value['description'],
        'url': value['url'],
    };
}

